import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
import { Tooltip, useSharedTooltipProvider } from './tooltip.js';
/**
 * A kit tooltip around a single element instead of the system `title`: opens
 * on hover AND on keyboard focus, and reads the same everywhere. Outside the
 * app-wide `Tooltip.SharedProvider` (tests, a detached render) it brings its
 * own provider, so it works standalone.
 *
 * Not for paragraphs: an explanation that has to stay open while it is read
 * goes into `HelpHint` (a popover).
 */
export function Hint({ content, children, side = 'top', align = 'center', collisionPadding = 8, className, }) {
    const shared = useSharedTooltipProvider();
    const tip = (_jsxs(Tooltip.Root, { children: [_jsx(Tooltip.Trigger, { asChild: true, children: children }), _jsx(Tooltip.Content, { side: side, align: align, collisionPadding: collisionPadding, className: cn('max-w-xs whitespace-normal leading-snug', className), children: content })] }));
    return shared ? tip : _jsx(Tooltip.Provider, { delayDuration: 300, children: tip });
}
//# sourceMappingURL=hint.js.map